<template>
  <div v-if="libraryList.length > 0">
    <ul>
      <li
        class="border-bottom item-body"
        data-arrow="false"
        v-for="(item, index) in libraryList"
        :key="item.activation_key"
        :style="[index >= counter ? styleObject : '']"
        :class="{'-over': item.is_over}">
        <!-- <div class="caption" v-if="isOutputDate(item.paid_at)">購入日：{{item.paid_at}}</div> -->
        <div class="item-wrap">
          <span class="label" :class="getLabelBgColor(item.predelivery)">{{getLabelMessage(item.predelivery, item.service_type)}}</span>
          <a :href="`${item.result_url}`">
            <div class="libraryList">
              <div class="media__image" data-size="xm">
                <uranai-img
                data-clip-path-support="true"
                size="xm"
                :src="`${item.pack_image}`"
                :alt="`${item.item_name}`"
                ></uranai-img>
              </div>
              <div class="libraryList__list">
                <div class="media__text">
                  <div class="media__content">
                    <div class="media__title mg-b-sm">{{item.item_name}}</div>
                    <div class="media__counselorname u-mg-b-1" v-if="item.name">
                      <p v-if="item.custom_item !== 1">占い師：{{item.name}}</p>
                    </div>
                    <!--
                    <div class="tagarea u-mg-b-1">
                      <span class="badge">{{item.service_type_name}}</span>
                      <span v-if="item.category_tag_name" :class="`badge u-tag-${item.category_tag_id}`">{{item.category_tag_name}}</span>
                    </div>
                    -->
                    <div class="delivery-date" v-if="item.predelivery === 1 && !item.is_over">{{getDeliveryDate(item.order_limit)}}までにお届けします</div>
                    <div class="delivery-over" v-if="item.is_over">【閲覧可能期間が終了しました】</div>
                  </div>
                </div>
                <div class="libraryList__itemfoot">
                  <link-icon :icon-type="item.service_type_name === 'テキスト' ? 0 : 1"/>
                </div>
              </div>
            </div>
          </a>
        </div>
      </li>
    </ul>
    <div class="btn_showmore" v-if="this.libraryList.length >= 4" ref="btnshowmoreMovie" @click="clickOpen()">
      <div class="inner">
        <span class="inner_text" >もっと見る</span>
      </div>
    </div>
  </div>
</template>

<script>
import LinkIcon from "@/utvStore/components/partials/LinkIcon";
export default {
  name: 'libraryList',
  data() {
    return {
      libraryList: [],
      styleObject: {
        display: 'none'
      },
      counter: 10000 // もっと見るボタンリリース時はここの値を3にする。
    };
  },
  components:{
    LinkIcon
  },
  props: {
    libraryListReceive: {
      type: Array,
      default() {
        return []
      }
    }
  },
  created() {
    this.libraryList = [...this.libraryListReceive]
    // this.libraryList = JSON.parse(this.$attrs['data-library']);
  },
  mounted() {
    if (this.$refs.btnshowmoreMovie) {
      this.$refs.btnshowmoreMovie.style.display = 'none'; // もっと見るボタンリリース時はmountedごとここを削除
    }
  },
  methods: {
    clickOpen() {
      this.counter += 5;
      if (this.counter >= this.libraryList.length) this.$refs.btnshowmoreMovie.style.display = 'none';
    },
    getLabelMessage(status, servicetype) {
      let msg = '';
      if (status === 1) {
        if (servicetype === 6) {
          msg = '制作中';
        } else {
          msg = '撮影中';
        }
      }
      return msg;
    },
    getLabelBgColor(status) {
      let bgColor = '';
      if (status === 1) {
        bgColor = 'bgBlack';
      }
      return bgColor;
    },
    isOutputDate(date) {
      let isOutput = false;
      if (this.date !== date) {
        this.date = date;
        isOutput = true;
      }
      return isOutput;
    },
    getDeliveryDate(date) {
      date = date.replace(/\//g, '-');
      return (
        moment(date)
          //        .add(7, 'day')
          .format('YYYY/MM/DD(ddd)23:59')
      );
    }
  }
}</script>

<style lang="scss">
.rightarrow {
  background-image: url('/static/img/common/arrow_right_lightgray.svg');
  background-repeat: no-repeat;
  background-size: 9px 14px;
  background-position: right center;
  padding-right: 15px;
  margin-right: 3px;
}
.border-bottom {
  border-bottom: 1px solid #DCDFE2;
  margin: 0 -20px;
}
.item-body {
  .item-wrap {
    width: 100%;
    position: relative;
    .label {
      position: absolute;
      top: 28px;
      left: 20px;
    }
  }
}
.delivery-date {
  font-family: 'Hiragino Kaku Gothic Pro';
  line-height: 15px;
  font-size: 10px;
  color: #ed1e79;
  font-weight: bold;
}
.delivery-over {
  line-height: 1.25;
  font-size: 12px;
  font-weight: bold;
  color: black;
}
.bgBlack {
  background: black;
}
.label {
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 10px;
  color: #ffffff;
  position: absolute;
  z-index: 10;
  padding: 3px 6px;
  line-height: 10px;
}
.mg-b-sm {
  margin-bottom: 4px;
}
.btn_showmore {
  .inner {
    height: 48px;
    text-align: center;
    padding: 12px 0;
  }
  .inner_text {
    color: black;
    font-family: 'Hiragino Kaku Gothic Pro';

    &:after {
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background-image: url('/static/img/common/arrow_down_black.svg');
      background-size: contain;
      vertical-align: middle;
      margin-left: 8px;
    }
  }
}
.-over {
  pointer-events: none;
  .rightarrow {
    background-image: none;
  }
  .label,
  .tagarea {
    opacity: 0.3;
  }
  .media {
    &__image,
    &__title,
    &__counselor {
      opacity: 0.3;
    }
  }
}

.libraryList{
  display: flex;
  padding: 20px;

  &__list{
    width: 100%;
    position: relative;
  }

  &__itemfoot{
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

a{
  text-decoration: none;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/PaymentLibraryList.vue